import React, { useState, useEffect } from 'react';

import { useTheme } from 'styled-components';
import Moment from 'moment';
import { toast } from 'react-toastify';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';

import { FaList } from 'react-icons/fa';
import { FaFilter } from 'react-icons/fa';
import { FaFileExcel } from 'react-icons/fa';

import { IoMdArrowDropup, IoMdClose } from 'react-icons/io';

import api from '~/services/api';

import { progressoGeracaoRelatorio } from '~/helpers/download';
import { exportXlsx } from '~/helpers/xlsx';
import { sanitize } from '~/helpers/text';

import {
  Scroll,
  Container,
  Header,
  Grid,
  GridLine,
  GridHeadItem,
  GridItem,
  Progress,
  Loading,
  Area,
  Summary,
  Footer,
  Cancel,
  Button,
  Stack,
  Checkbox,
  Box,
  Label,
  Pagination,
} from '~/components';

import { LoadArea, Tag, Status, TypeTag } from '../Painel/styles';

import { Align } from '../Produtos/styles';

import EstoquePreditivoType from '~/@types/estoquepreditivo';

import {
  ClearFiltersBtn,
  FiltersZone,
  FiltersZoneContent,
  FiltersZoneHeader,
  Reflection,
} from '../Pedidos/styles';
import { agora } from '~/helpers/date';

let lang = require('moment/locale/pt-br');
Moment.locale('pt-br', lang);

const EstoquePreditivo: React.FC = () => {
  const history = useHistory();

  const { colors } = useTheme();

  const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  };

  let query = useQuery();

  const [inLoad, setInLoad] = useState(false);
  const [inSync, setInSync] = useState(false);
  const [inSyncProgress, setInSyncProgress] = useState(0);

  // FILTROS
  const [filtersVisible, setFiltersVisible] = useState(false);

  // FILTROS (OPÇÕES)
  const [status, setStatus] = useState('');
  const [tendencia, setTendencia] = useState('');
  const [giro, setGiro] = useState('');
  const [classeabc, setClasseabc] = useState('');
  const [ordenarpor, setOrdenarpor] = useState('');

  // PAGINAÇÃO
  const [pagina, setPagina] = useState('1');
  const [totalpaginas, setTotalpaginas] = useState('1');
  const [totalitens, setTotalitens] = useState('1');

  const alterarPagina = (pPagina: string) => {
    setPagina(pPagina);
    aplicarFiltros(tendencia, giro, classeabc, status, ordenarpor, pPagina);
  };

  // FILTROS
  const toggleFilters = () => {
    setFiltersVisible(!filtersVisible);
  };

  const [dados, setDados] = useState<EstoquePreditivoType[]>([]);

  // RESETAR FILTROS
  const resetar = () => {
    setStatus('');
    setTendencia('');
    setGiro('');
    setClasseabc('');
    setOrdenarpor('');
    aplicarFiltros('', '', '', '', '', '');
    toggleFilters();
  };

  const aplicarFiltros = async (
    pIntegradoERP: string,
    pGiro: string,
    pClasseabc: string,
    pStatus: string,
    pOrdenarPor: string,
    pPagina: string,
  ) => {
    try {
      setInLoad(true);
      setDados([]);
      setFiltersVisible(false);

      const urlParams = qs.stringify(
        {
          status: pStatus && pStatus !== '' ? pStatus : null,
          tendencia:
            pIntegradoERP && pIntegradoERP !== '' ? pIntegradoERP : null,
          giro: pGiro && pGiro !== '' ? pGiro : null,
          classeabc: pClasseabc && pClasseabc !== '' ? pClasseabc : null,
          ordenarpor: pOrdenarPor && pOrdenarPor !== '' ? pOrdenarPor : null,
          pagina: pPagina && pPagina !== '' ? pPagina : null,
        },
        {
          skipNulls: true,
        },
      );

      history.push({
        pathname: '/estoque-preditivo',
        search: `?${urlParams}`,
      });

      const response = await api.get(
        `analise-de-produtos/estoque-preditivo?${urlParams}`,
      );

      const { data } = response;

      if (data) {
        const {
          dados,
          totalpaginas: cTotalpaginas,
          totalitens: cTotalitens,
        } = data;
        setDados(dados);
        setTotalpaginas(cTotalpaginas);
        setTotalitens(cTotalitens);
      }

      setInLoad(false);
    } catch (e) {
      setInLoad(false);
    }
  };

  const gerarRelatorioCSV = async () => {
    try {
      const dadosplanilha: EstoquePreditivoType[] = [];

      setInSync(true);
      setInSyncProgress(1);

      let p;
      for (p = 1; p <= Number(totalpaginas); p++) {
        setInSyncProgress(p);

        const urlParams = qs.stringify(
          {
            status: status && status !== '' ? status : null,
            tendencia: tendencia && tendencia !== '' ? tendencia : null,
            giro: giro && giro !== '' ? giro : null,
            classeabc: classeabc && classeabc !== '' ? classeabc : null,
            ordenarpor: ordenarpor && ordenarpor !== '' ? ordenarpor : null,
            pagina: p,
          },
          {
            skipNulls: true,
          },
        );

        const response = await api.get(
          `analise-de-produtos/estoque-preditivo?${urlParams}`,
        );

        const { data } = response;

        if (data) {
          const { dados } = data;
          if (dados && Array.isArray(dados) && dados.length) {
            let d;
            for (d in dados) {
              const item = dados[d];
              dadosplanilha.push(item);
            }
          }
        }
      }

      let sheetData: string[] = [];

      sheetData.push(
        'SKU;ITEM;CLASSE;STATUS;ESTOQUE;AUTONOMIA;SUGESTÃO;ALVO;SEGURANÇA;TENDÊNCIA',
      );

      let c;
      for (c in dadosplanilha) {
        const item = dadosplanilha[c];
        sheetData.push(
          `${item.sku};${item.nome};${item.classeabc};${item.status};${item.estoque};${item.autonomiadias};${item.sugestaocompra};${item.estoquealvo};${item.estoqueseguranca};${item.tendencia}`,
        );
      }

      const csv = sheetData.join('\n');

      exportXlsx(csv, `COMMERCEPLUS - ESTOQUE PREDITIVO - ${agora()}`);

      toast.success('Planilha gerada com sucesso!');

      setInSync(false);
    } catch (e) {
      toast.error(`${(e as Error).message}`);
    }
  };

  const exibirReflexao = () => {
    if (
      query.get('busca') ||
      query.get('tendencia') ||
      query.get('giro') ||
      query.get('classeabc') ||
      query.get('dtfinal') ||
      query.get('dtinicio') ||
      query.get('status')
    ) {
      return true;
    }
    return false;
  };

  const verificarReflexao = (pNome: string) => {
    if (query.get(pNome)) {
      return true;
    }
    return false;
  };

  const removerReflexao = (pNome: string) => {
    query.delete(pNome);
    history.push({
      pathname: '/estoque-preditivo',
      search: `?${query.toString()}`,
    });
  };

  useEffect(() => {
    const sTendencia = query.get('tendencia') || '';
    const sFaturado = query.get('giro') || '';
    const sClasseabc = query.get('classeabc') || '';
    const sStatus = query.get('status') || '';
    const sOrdenarPor = query.get('ordenarpor') || '';
    const sPagina = query.get('pagina') || '';

    setTendencia(sTendencia);
    setGiro(sFaturado);
    setClasseabc(sClasseabc);
    setStatus(sStatus);
    setOrdenarpor(sOrdenarPor);
    setPagina(sPagina);

    aplicarFiltros(
      sTendencia,
      sFaturado,
      sClasseabc,
      sStatus,
      sOrdenarPor,
      sPagina,
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            title="Estoque Preditivo"
            subtitle="Análise preditiva de estoque em curto, médio e longo prazo"
            isFilters
            toggleFilters={toggleFilters}
            icon={
              <>
                <FaList size={26} color={colors.IC1} />
              </>
            }
          />

          {filtersVisible ? (
            <FiltersZone>
              <FiltersZoneHeader>
                <div>
                  <FaFilter size={22} color={colors.IC1} />
                  <h1>FILTROS</h1>
                </div>
                <button onClick={toggleFilters} title="Fechar os filtros">
                  <IoMdArrowDropup size={36} color={colors.IC1} />
                </button>
              </FiltersZoneHeader>
              <FiltersZoneContent>
                <Stack>
                  <Label
                    number="1"
                    label="Status"
                    subtitle="Selecione o status do pedido"
                    status={!!status}
                  />
                  <Box>
                    <Checkbox
                      label="Comprar Urgente"
                      onClick={() => setStatus('Comprar Urgente')}
                      status={status === 'Comprar Urgente'}
                    />
                    <Checkbox
                      label="Em Falta"
                      onClick={() => setStatus('Em Falta')}
                      status={status === 'Em Falta'}
                    />
                    <Checkbox
                      label="Estoque Alto"
                      onClick={() => setStatus('Estoque Alto')}
                      status={status === 'Estoque Alto'}
                    />
                    <Checkbox
                      label="Ruptura Crítica"
                      onClick={() => setStatus('Ruptura Crítica')}
                      status={status === 'Ruptura Crítica'}
                    />
                    <Checkbox
                      label="Saudável"
                      onClick={() => setStatus('Saudável')}
                      status={status === 'Saudável'}
                    />
                    <Checkbox
                      label="Sem Estoque"
                      onClick={() => setStatus('Sem Estoque')}
                      status={status === 'Sem Estoque'}
                    />
                  </Box>
                </Stack>

                <Stack>
                  <Label
                    number="2"
                    label="Tendência"
                    subtitle="Selecione a tendência"
                    status={!!tendencia}
                  />
                  <Box>
                    <Checkbox
                      label="Crescendo"
                      onClick={() => setTendencia('Crescendo')}
                      status={tendencia === 'Crescendo'}
                    />
                    <Checkbox
                      label="Caindo"
                      onClick={() => setTendencia('Caindo')}
                      status={tendencia === 'Caindo'}
                    />
                    <Checkbox
                      label="Estável"
                      onClick={() => setTendencia('Estável')}
                      status={tendencia === 'Estável'}
                    />
                    <Checkbox
                      label="Sem Estoque"
                      onClick={() => setTendencia('Sem Estoque')}
                      status={tendencia === 'Sem Estoque'}
                    />
                  </Box>
                </Stack>

                <Stack>
                  <Label
                    number="3"
                    label="Giro"
                    subtitle="Selecione o giro"
                    status={!!giro}
                  />
                  <Box>
                    <Checkbox
                      label="Giro Alto"
                      onClick={() => setGiro('Giro Alto')}
                      status={giro === 'Giro Alto'}
                    />
                    <Checkbox
                      label="Giro Médio"
                      onClick={() => setGiro('Giro Médio')}
                      status={giro === 'Giro Médio'}
                    />
                    <Checkbox
                      label="Giro Baixo"
                      onClick={() => setGiro('Giro Baixo')}
                      status={giro === 'Giro Baixo'}
                    />
                    <Checkbox
                      label="Sem Giro"
                      onClick={() => setGiro('Sem Giro')}
                      status={giro === 'Sem Giro'}
                    />
                  </Box>
                </Stack>

                <Stack>
                  <Label
                    number="4"
                    label="Classe"
                    subtitle="Selecione a classeabc ABC"
                    status={!!classeabc}
                  />
                  <Box>
                    <Checkbox
                      label="A"
                      onClick={() => setClasseabc('A')}
                      status={classeabc === 'A'}
                    />
                    <Checkbox
                      label="B"
                      onClick={() => setClasseabc('B')}
                      status={classeabc === 'B'}
                    />
                    <Checkbox
                      label="C"
                      onClick={() => setClasseabc('C')}
                      status={classeabc === 'C'}
                    />
                    <Checkbox
                      label="N"
                      onClick={() => setClasseabc('N')}
                      status={classeabc === 'N'}
                    />
                    <Checkbox
                      label="SE"
                      onClick={() => setClasseabc('SE')}
                      status={classeabc === 'SE'}
                    />
                  </Box>
                </Stack>

                <Stack>
                  <Label
                    number="5"
                    label="Ordenar Por"
                    subtitle="Selecione a ordem dos registros"
                    status={!!ordenarpor}
                  />
                  <Box>
                    <Checkbox
                      label="Ranking Financeiro"
                      onClick={() => setOrdenarpor('rankingfinanceiro')}
                      status={ordenarpor === 'rankingfinanceiro'}
                    />
                    <Checkbox
                      label="Ranking Volume"
                      onClick={() => setOrdenarpor('rankingvolume')}
                      status={ordenarpor === 'rankingvolume'}
                    />
                    <Checkbox
                      label="Faturamento"
                      onClick={() => setOrdenarpor('faturamento')}
                      status={ordenarpor === 'faturamento'}
                    />
                    <Checkbox
                      label="Classe ABC"
                      onClick={() => setOrdenarpor('classeabc')}
                      status={ordenarpor === 'classeabc'}
                    />
                  </Box>
                </Stack>

                <Footer>
                  <Button
                    onClick={() => {
                      toggleFilters();
                      aplicarFiltros(
                        tendencia,
                        giro,
                        classeabc,
                        status,
                        ordenarpor,
                        '',
                      );
                    }}
                  >
                    APLICAR
                  </Button>
                  <Cancel onClick={resetar}>Resetar</Cancel>
                </Footer>
              </FiltersZoneContent>
            </FiltersZone>
          ) : null}

          {inLoad ? (
            <LoadArea>
              <Loading color={colors.IC1} size={42} />
            </LoadArea>
          ) : null}

          {!inLoad ? (
            <Summary>
              {dados.length ? (
                <main>
                  <h1>
                    {dados.length > 1
                      ? `${dados.length} de ${totalitens} produtos em tela`
                      : `Um produtos em tela`}
                  </h1>
                  <h2>{`Página ${
                    pagina && pagina !== '' ? pagina : 1
                  } de ${totalpaginas}`}</h2>
                </main>
              ) : (
                <h1>{`Nenhum produto em tela (${
                  pagina && pagina !== '' ? pagina : 1
                }/${totalpaginas})`}</h1>
              )}
              <div>
                {dados.length ? (
                  <>
                    <button
                      className={inSync ? 'excel inload' : 'excel'}
                      onClick={gerarRelatorioCSV}
                      title={
                        inSync
                          ? `Gerando planilha (${progressoGeracaoRelatorio(
                              inSyncProgress,
                              Number(totalpaginas),
                            )}%)`
                          : 'Exportar para Excel'
                      }
                      disabled={inSync}
                    >
                      {inSync ? (
                        <>
                          <Loading size={22} color={colors.IC2} />
                          <div>
                            <h3>
                              {`GERANDO (${progressoGeracaoRelatorio(
                                inSyncProgress,
                                Number(totalpaginas),
                              )}%)`}
                            </h3>
                            <h2>EXCEL</h2>
                          </div>
                        </>
                      ) : (
                        <>
                          <FaFileExcel size={22} color={colors.IC2} />
                          <div>
                            <h3>EXPORTAR</h3>
                            <h2>EXCEL</h2>
                          </div>
                        </>
                      )}
                    </button>
                  </>
                ) : null}
              </div>
            </Summary>
          ) : null}

          {!inLoad && exibirReflexao() ? (
            <Reflection>
              <h1>Filtros ativos:</h1>
              <main>
                {verificarReflexao('status') ? (
                  <div>
                    <button onClick={() => removerReflexao('status')}>
                      <IoMdClose size={26} color={colors.IC1} />
                    </button>
                    <span>
                      <strong>STATUS:</strong>
                      <small>{status}</small>
                    </span>
                  </div>
                ) : null}
                {verificarReflexao('tendencia') ? (
                  <div>
                    <button onClick={() => removerReflexao('tendencia')}>
                      <IoMdClose size={26} color={colors.IC1} />
                    </button>
                    <span>
                      <strong>TENDÊNCIA:</strong>
                      <small>{tendencia}</small>
                    </span>
                  </div>
                ) : null}
                {verificarReflexao('giro') ? (
                  <div>
                    <button onClick={() => removerReflexao('giro')}>
                      <IoMdClose size={26} color={colors.IC1} />
                    </button>
                    <span>
                      <strong>GIRO:</strong>
                      <small>{giro}</small>
                    </span>
                  </div>
                ) : null}

                {verificarReflexao('classeabc') ? (
                  <div>
                    <button onClick={() => removerReflexao('classeabc')}>
                      <IoMdClose size={26} color={colors.IC1} />
                    </button>
                    <span>
                      <strong>CLASSEABC:</strong>
                      <small>{classeabc}</small>
                    </span>
                  </div>
                ) : null}
                {verificarReflexao('ordenarpor') ? (
                  <div>
                    <button onClick={() => removerReflexao('ordenarpor')}>
                      <IoMdClose size={26} color={colors.IC1} />
                    </button>
                    <span>
                      <strong>ORDENAR POR:</strong>
                      <small>{ordenarpor}</small>
                    </span>
                  </div>
                ) : null}
              </main>
              <ClearFiltersBtn onClick={resetar}>
                LIMPAR TODOS OS FILTROS
              </ClearFiltersBtn>
            </Reflection>
          ) : null}

          {!inLoad ? (
            <Area>
              <Grid>
                <GridLine>
                  <GridHeadItem title="SKU / Item" />
                  <GridHeadItem title="Classe" width={80} />
                  <GridHeadItem title="Status" width={140} />
                  <GridHeadItem title="Estoque" width={80} />
                  <GridHeadItem title="Autonomia" width={120} />
                  <GridHeadItem title="Sugestão" width={120} />
                  <GridHeadItem title="Alvo" width={80} />
                  <GridHeadItem title="VMD" width={200} />
                  <GridHeadItem title="Tendência" width={150} />
                </GridLine>

                {dados.map(estoque => (
                  <GridLine key={estoque.idproduto}>
                    <GridItem>
                      <Align>
                        <div
                          style={{
                            marginBottom: 5,
                          }}
                        >
                          {estoque.nome}
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}
                        >
                          <strong style={{ marginRight: 5 }}>
                            {estoque.sku}
                          </strong>
                          <TypeTag>{estoque.tipo}</TypeTag>
                        </div>
                      </Align>
                    </GridItem>
                    <GridItem width={80}>
                      <Align>
                        <Tag
                          className={`classe-${sanitize(estoque.classeabc)}`}
                        >
                          {estoque.classeabc}
                        </Tag>
                      </Align>
                    </GridItem>
                    <GridItem width={140}>
                      <Align>
                        <Status className={sanitize(estoque.status)}>
                          {estoque.status}
                        </Status>
                      </Align>
                    </GridItem>

                    <GridItem width={80}>
                      <Align>{estoque.estoque}</Align>
                    </GridItem>
                    <GridItem width={120}>
                      <Align>{`${estoque.autonomiadias} ${
                        Number(estoque.autonomiadias) > 1 ? ' dias' : ' dia'
                      }`}</Align>
                    </GridItem>
                    <GridItem width={120}>
                      <Align>
                        <div>
                          Comprar <strong>{estoque.sugestaocompra}</strong>
                        </div>
                      </Align>
                    </GridItem>
                    <GridItem width={80}>
                      <Align>{estoque.estoquealvo}</Align>
                    </GridItem>

                    <GridItem width={200}>
                      <Align>
                        <div>
                          Preditivo: <strong>{estoque.vmdpred}</strong>
                        </div>
                        <div>
                          Período: <strong>{estoque.vmd}</strong>
                        </div>
                      </Align>
                    </GridItem>

                    <GridItem width={150}>
                      <Align>
                        <Status className={estoque.tendencia.toLowerCase()}>
                          {estoque.tendencia}
                        </Status>
                      </Align>
                    </GridItem>
                  </GridLine>
                ))}
              </Grid>
            </Area>
          ) : null}

          {!inLoad ? (
            <Pagination
              page={pagina}
              totalpages={totalpaginas}
              onChange={alterarPagina}
            />
          ) : null}
        </Container>
      </Scroll>
    </>
  );
};

export default EstoquePreditivo;
